import React, { Component } from "react"
import PropTypes from "prop-types"
import { Provider } from "react-redux"
import routes from "./routes"
import { Router } from "react-router"
import { ThemeProvider } from "emotion-theming"
import theme from "ui/styleHelpers/stackerTheme"
import { Route, IndexRoute } from "react-router"

// For the DemoRoute
import App from "./App"
import ViewPageFromUrl from "features/pages/ViewPageFromUrl"

// import withDragDropContext from "components/_Editor/DragAndDrop/withDragDropContext"

class Root extends Component {
    render() {
        const { store, history } = this.props

        // Check if we're on the main domain. If so, then
        let selectedRoutes
        if (
            window.location.hostname === "localhost" ||
            window.location.hostname === "app.stackerlabs.com" ||
            window.location.hostname === "stacker-frontend.firebaseapp.com" ||
            window.location.hostname === "studio.stacker.app" ||
            window.location.hostname === "app.stacker.app"
        ) {
            selectedRoutes = routes
        } else {
            // here we
            selectedRoutes = demoRoutes
        }
        return (
            <Provider store={store}>
                <ThemeProvider theme={theme}>
                    <Router history={history} routes={selectedRoutes} />
                </ThemeProvider>
            </Provider>
        )
    }
}

Root.propTypes = {
    store: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
}

//export default withDragDropContext(Root)
export default Root

const demoRoutes = (
    <Route path="/*" component={App}>
        <Route path="logout" component={ViewPageFromUrl} onEnter={logOut} />
        <IndexRoute component={ViewPageFromUrl} />
    </Route>
)
//onEnter={requireAuth}
export function logOut(nextState, replace, next) {
    window.Intercom("boot", {
        app_id: (window.location.hostname === "studio.stacker.app" ? "txwvzciy" : "bu5482h5"),
        //Logged out user so may not have any user related info
    })
    localStorage.setItem("studio_token", "")
    localStorage.setItem("user_token", "")
    next()
}



// WEBPACK FOOTER //
// ./src/app/Root.js